import { defineMessages } from 'react-intl';

import { TVibeType } from '@/services/types/search/rentals/id';

export const VIBE_BADGE_MESSAGES = defineMessages<TVibeType>({
  adventure: {
    defaultMessage: 'Guests love it for adventure',
    id: 'NjG6ZX',
    description: 'Listing > Guest Reviews > Vibe spotlight badge for adventure listings',
  },
  family: {
    defaultMessage: 'Guests love it for families',
    id: 'Pi21w6',
    description: 'Listing > Guest Reviews > Vibe spotlight badge for family-friendly listings',
  },
  beginner: {
    defaultMessage: 'Guests love it for first-timers',
    id: 'HJ6lIj',
    description: 'Listing > Guest Reviews > Vibe spotlight badge for beginner-friendly listings',
  },
  comfort: {
    defaultMessage: 'Guests love it for comfort',
    id: 'CjMgrj',
    description: 'Listing > Guest Reviews > Vibe spotlight badge for comfort-focused listings',
  },
  luxury: {
    defaultMessage: 'Guests love it for luxury',
    id: '/kbL99',
    description: 'Listing > Guest Reviews > Vibe spotlight badge for luxury listings',
  },
});
